import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */
import { FormulaElementModelAdaptor } from "abreact/expression/formula/framework/FormulaElementModelAdaptor";
import { FormulaElementType } from "abreact/expression/formula/framework/FormulaElementType";
import { GuidedExpressionEditorUtils } from "abreact/expression/ui/editor/impl/utils/GuidedExpressionEditorUtils";
import { SummaryElement, SummaryElementType } from "abreact/expression/ui/editor/readonly/ExpressionSummaryElement";
import { ExpExpressionNodeNodeTypeEnum } from "abweb/generated/abwebinternal/api/dto/ExpExpressionNode";
export class FormulaCustomOperatorContributor {
  get identifier() {
    return FormulaCustomOperatorContributor.IDENTIFIER;
  }
  appliesToNode(node) {
    return node && node.additionalData?.type === FormulaElementModelAdaptor.ADDITIONAL_DATA_FORMULA_TEMPLATE_TYPE;
  }
  contributeOperator(model, expExpressionNode, summaryMode, structureNode) {
    let templateJson = expExpressionNode.additionalData.values["template"];
    let template = JSON.parse(templateJson);
    let valueNodeToOperandValueMap = new Map();
    let expExpressionNodesSet = new Set();
    GuidedExpressionEditorUtils.collectExpExpressionNodesRecursive(expExpressionNode, expExpressionNodesSet);
    expExpressionNodesSet.forEach(node => {
      valueNodeToOperandValueMap.set(node.id, node);
    });
    template.forEach(element => {
      if (FormulaElementModelAdaptor.isFormulaElementNonValueType(element)) {
        let summaryElementType = SummaryElementType.TEXT;
        let classNameSuffix = element;
        switch (element) {
          case FormulaElementType.OPERATOR_ADD:
            classNameSuffix = "add";
            break;
          case FormulaElementType.OPERATOR_DIVIDE:
            classNameSuffix = "divide";
            break;
          case FormulaElementType.OPERATOR_MULTIPLY:
            classNameSuffix = "multiply";
            break;
          case FormulaElementType.OPERATOR_SUBTRACT:
            classNameSuffix = "subtract";
            break;
          case FormulaElementType.PAREN_LEFT:
          case FormulaElementType.PAREN_RIGHT:
            classNameSuffix = "paren";
            break;
          default:
        }
        model.currentRow.addElement(new SummaryElement(summaryElementType, element, {
          cssClassName: `ab-gee-summary-formula-element ab-gee-summary-formula-element-math ab-gee-summary-formula-element-${classNameSuffix}`
        }));
      } else {
        let value = valueNodeToOperandValueMap.get(element);
        if (value) {
          if (value.nodeType === ExpExpressionNodeNodeTypeEnum.OPERATOR) {
            structureNode.contributeOperator(model, value, summaryMode, value.operatorID);
          } else {
            model.currentRow.addElement(new SummaryElement(SummaryElementType.LEAF, value));
          }
        }
      }
    });
  }
}
_defineProperty(FormulaCustomOperatorContributor, "IDENTIFIER", "formula");
//# sourceMappingURL=FormulaCustomOperatorContributor.js.map
